// extracted by mini-css-extract-plugin
export var autoExpand = "_38-b";
export var container = "_38-a";
export var containerWidth = "_38-8";
export var disabled = "_38-2";
export var error = "_38-3";
export var fullWidth = "_38-9";
export var highlightContainer = "_38-5";
export var inputWrapper = "_38-0";
export var small = "_38-1";
export var textarea = "_38-4";
export var validatedTextarea = "_38-6";
export var visuallyHidden = "_38-7";